import React from 'react';

import Settings from '@atlaskit/icon/glyph/settings';
import { openDialog } from 'src/services/jira';

function onClick() {
  openDialog('/integration-jira-ui/issue_sidebar/modal_sidebar_settings', { width: '60vw', minHeight: 300 });
}
const SettingsButton = () => (
  <div className="icon" onClick={onClick} data-cy="sidebar-ui-settings-button"><Settings/></div>
);

export default SettingsButton;
